import CustomReport from './CustomReport';
import './CustomReport.scss';

export default CustomReport;
